import { Component, OnInit } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { ICON } from '@core/util/icon';
import { DialogRef } from '@angular/cdk/dialog';
import { NgxPrintService, PrintOptions } from 'ngx-print';
import { TestHooks } from './summary-docket.hooks';
import {
	SummaryDocketComponentSelector,
	SummaryDocketComponentState,
} from './summary-docket.selector';
import { TeranetService } from '@services/teranet/teranet.service';
import { NavigationService } from '@services/nav/nav.service';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { DocketSummaries } from '@models/teranet';

@Component({
	selector: 'app-teranet-summary-docket',
	templateUrl: './summary-docket.component.html',
	standalone: false,
})
export class SummaryDocketComponent implements OnInit {
	testHooks = TestHooks;
	@SelectSnapshot(SummaryDocketComponentSelector.getSummaryDocketComponentState)
	summaryDocketState: SummaryDocketComponentState;
	@SelectSnapshot(SelectedMatter.id) matterId: string;

	public loading = true;
	public error: string;
	public noDocket = false;
	public ICON = ICON;
	public summaries: DocketSummaries;
	public docketTitle: string;

	constructor(
		private teranetService: TeranetService,
		private modal: DialogRef<SummaryDocketComponent>,
		private printService: NgxPrintService,
		private navService: NavigationService,
	) {}

	async ngOnInit(): Promise<void> {
		if (this.summaryDocketState.docket?.docketTeranetSystemId) {
			const result = await this.teranetService.getDocketSummaries({
				docket_system_id: this.summaryDocketState.docket.docketTeranetSystemId,
				createdAt: this.summaryDocketState.createdAt,
				matterHST: this.summaryDocketState.hst,
				feeSettings: this.summaryDocketState.titleSearchFeeSettings,
			});
			if ('errorMessage' in result) {
				this.error = result.errorMessage;
			} else {
				this.summaries = result;
			}
		} else {
			this.noDocket = true;
		}
		this.loading = false;
		this.docketTitle = `#${this.summaryDocketState.matterNumber} | ${this.summaryDocketState.matterName}`;
	}

	createDocket = () => {
		this.closeModal();
		this.navService.goToMatter_TitleSearch_Stepper_Search(this.matterId);
	};

	printDocket = () => {
		const customPrintOptions: PrintOptions = new PrintOptions({
			printSectionId: 'docket-summary',
			printTitle: this.docketTitle,
			useExistingCss: true,
			openNewTab: false,
		});
		this.printService.print(customPrintOptions);
	};

	closeModal() {
		this.modal.close();
	}
}
